import { v4 as uuidv4 } from "uuid";
import querystring from "querystring";
import Url from "url";
import moment from "moment-timezone";
import I18n from "../../../translations/i18n";

moment.locale(I18n.locale);

export const handleOverlayOpen = () => {
  const scrollY = window.scrollY;
  document.body.style.height = "100vh";
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.paddingRight = "15px";
  return "";
};

/**
 * Stops the page from scrolling back to the top
 */
export const handleOverlayClose = () => {
  const scrollY = document.body.style.top;
  if (scrollY) {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.paddingRight = "";
    document.body.style.height = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }
};

export const uuid = uuidv4();

export const calculateDownloadUrl = (downloadUrl: string, referrer: string) => {
  const queryStringMatch = downloadUrl.match(/\?(.*)$/);
  const qs = queryStringMatch ? querystring.parse(queryStringMatch[1]) : {};
  // update the query string of the URL
  const redirectUrlQs = querystring.parse(location.search.replace(/^\?/, ""));
  redirectUrlQs.new_download = "true";
  redirectUrlQs.gopher_installed = "true";
  if (referrer) {
    const parentUrl = Url.parse(referrer);
    console.log("** parentUrl = ", parentUrl);
    qs.redirect_url = `${parentUrl.protocol}//${parentUrl.hostname}${
      parentUrl.pathname
    }?${querystring.stringify(redirectUrlQs)}`;
  } else {
    qs.redirect_url = `${location.origin}${
      location.pathname
    }?${querystring.stringify(redirectUrlQs)}`;
  }
  let cleanedDownloadUrl = downloadUrl.replace(
    /\?.*$/,
    `?${querystring.stringify(qs)}`
  );
  return cleanedDownloadUrl;
};

declare const location: any;
